import Api from "../services/api";

export const getLocations = () => {
    return Api.get('/location');
}